import { useCallback, useState } from 'react'
import { DeepPartial, FieldValues, useForm } from 'react-hook-form'

export const useDeviceSettingForm = <T extends FieldValues>(getStoredValues: () => T) => {
  const [isLoading, setIsLoading] = useState(false)
  const {
    control,
    formState: { isDirty },
    handleSubmit,
    reset,
  } = useForm<T>({ defaultValues: getStoredValues() as DeepPartial<T> })

  const cancel = useCallback(() => {
    reset(getStoredValues())
  }, [reset, getStoredValues])

  return { control, isDirty, isLoading, setIsLoading, handleSubmit, reset, cancel }
}
